<div class="cron-management-page container-fluid">
    <mat-card appearance="outlined">
      <mat-card-content>
        <mat-tab-group [mat-stretch-tabs]="false" mat-align-tabs="start">
          <mat-tab label="Cron Jobs">
            <cron-job   [getCronJobsGroupedFn]="getCronJobsGroupedFn" [runCronJobFn]="runCronJobFn"></cron-job> 
          </mat-tab>

          <mat-tab label="Cron Job Instances">
             <cron-job-instance [getCronJobInstancesFn]="getCronJobInstancesFn"></cron-job-instance>
          </mat-tab>
        </mat-tab-group>      
      </mat-card-content>
    </mat-card>
</div>
